import { FileInfo } from '@app/models/document.model';
import { FileType } from '@app/models/shared.enums';

export function extractFilenameFromCD(header?: string | null): string | null {
  if (!header) return null;
  const star = header.match(/filename\*\s*=\s*([^']*)''([^;]+)/i);
  if (star?.[2]) return decodeURIComponent(star[2]);
  const plain = header.match(/filename\s*=\s*"?([^"]+)"?/i);
  return plain?.[1] ?? null;
}

export function saveBlob(blob: Blob, filename = 'download') {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const fileTypeIcon = (file?: FileInfo | null): string => {
  const type = file?.fileType as FileType | undefined;
  switch (type) {
    case FileType.mainImage:
    case FileType.image:
      return 'far fa-file-image';
    case FileType.video:
      return 'fas fa-file-video';
    case FileType.audio:
      return 'fas fa-file-audio';
    case FileType.documentValuation:
      return 'fas fa-file-pdf';
    case FileType.projectFinancialPlan1y:
    case FileType.projectFinancialPlan2y:
    case FileType.projectFinancialPlan3y:
    case FileType.projectFinancialPlanOther:
    case FileType.standardProjectDocument:
    case FileType.document:
    case FileType.documentCompanyRegistration:
    case FileType.documentTechnicalDescription:
    case FileType.userLegalEntityRightDocuProfessional:
    case FileType.userLegalEntityRightDocuPoAAuthorizedPartner:
    case FileType.userLegalEntityRightDocuPoAAuthorizedRepresentative:
    case FileType.userLegalEntityRightDocuAuthorizedRepresentativeSignatureSpecimen:
      break;
    default:
      break;
  }
  const ct = file?.contentType?.toLowerCase() ?? '';
  const extension = (file?.extension ?? '').toLowerCase();
  if (ct.includes('pdf') || extension === 'pdf') return 'fas fa-file-pdf';
  if (
    ct.startsWith('image/') ||
    ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(extension)
  )
    return 'far fa-file-image';
  if (ct.includes('excel') || ['xls', 'xlsx', 'csv'].includes(extension))
    return 'fas fa-file-excel';
  if (ct.includes('word') || ['doc', 'docx'].includes(extension))
    return 'fas fa-file-word';
  if (ct.includes('zip') || ['zip', 'rar', '7z'].includes(extension))
    return 'fas fa-file-archive';
  if (ct.includes('text') || ['txt', 'md'].includes(extension))
    return 'far fa-file-alt';
  return 'far fa-file';
};
